module.exports = __webpack_public_path__ + "img/poker-s08.8e69aa93.svg";